import React, { Component } from 'react'
import './front.css'
import { 
    userAuth_facebook,
    userAuth_google,
    vanAuth_facebook,
    vanAuth_google,
} from '../../config/firebase'

//_________________RE_USABLE_VARIABLES___________________//
let c = console

//_____________END___________________//


export default class Front extends Component {
    constructor(){
        super()
        this.state={
            userModal:false,vanModal:false,userlogin:false,vanlogin:false,
        }
    }
    
    //__________Checking_Auth____________//

    componentDidMount(){
        const user = JSON.parse(localStorage.getItem('user'))
        const van = JSON.parse(localStorage.getItem('van'))
        if(user){
            this.props.history.push('./user/registration')
        }
        else if(van){
            this.props.history.push('./driver/registration')
        }
    }

    // ____________________________USER-LOGIN_________________________________//
    async login(){
        this.setState({error:''})
        try{
           let user = await userAuth_facebook()
            c.log('auth_succes',user)
            let userDetail ={
                name:user.user.displayName,
                photo:user.user.photoURL,
                uid:user.user.uid
            }
            localStorage.setItem('user',JSON.stringify(userDetail))
           
            this.setState({
                userlogin:true,
                userDetail,
            })
        }
        catch(error){
               console.log('auth_Error',error.message)
               this.setState({error:error+' Please check your Internet'})
        }
    }

    async g_login(){
        this.setState({error:''})
        try {
            let user = await userAuth_google()
            c.log('g_usser',user)
            let userDetail ={
                name:user.user.displayName,
                photo:user.user.photoURL,
                uid:user.user.uid
            }
            localStorage.setItem('user',JSON.stringify(userDetail))
            this.setState({
                userlogin:true,
                userDetail,
            })
        } catch (error) {
            this.setState({error:error})
            c.log('g_error',error)
        }
    }
    //___________________________________USER-LOGIN-END_____________________________________//

    //___________________________VAN-LOGIN__________________________//


    async v_login(){
        this.setState({error:''})
        try{
           let user = await vanAuth_facebook()
            c.log('auth_succes_van',user)
            let userDetail ={
                name:user.user.displayName,
                photo:user.user.photoURL,
                uid:user.user.uid
            }
            localStorage.setItem('van',JSON.stringify(userDetail))
           
            this.setState({
                vanlogin:true,
                userDetail,
            })
        }
        catch(error){
               console.log('auth_Error_van',error.message)
               this.setState({error:error})
        }
    }

    async v_g_login(){
        this.setState({error:''})
        try {
            let user = await vanAuth_google()
            c.log('g_van',user)
            let userDetail ={
                name:user.user.displayName,
                photo:user.user.photoURL,
                uid:user.user.uid
            }
            localStorage.setItem('van',JSON.stringify(userDetail))
            this.setState({
                vanlogin:true,
                userDetail,
            })
        } catch (error) {
            this.setState({error:error})
            c.log('g_error_van',error)
        }
    }
    //_________________________VAN-LOGIN-END_______________________//

    

    render() {
        let { userModal,vanModal,userlogin,userDetail,error,vanlogin } = this.state;
        return (
            <div className='main_front'>
                <h1>A<h2>rriba</h2>!</h1>
                
                   
                    <button id='modalBtn' className='button' onClick={()=>this.setState({userModal:true,vanModal:false})}>SOU ESTUDANTE</button>
                     <button id='modalBtn' className='button' onClick={()=>this.setState({userModal:false,vanModal:true})}>SOU MOTORISTA</button>

{/* ===========================USER-MODAL======================== */}
{userModal &&
<div id='simpleModal' className='modal'>
    <div className='modal-content'>
        <div className='modal-header'>
        <span className='closeBtn' onClick={()=>this.setState({userModal:false})}>&times;</span>
        <h2>Login de usuário</h2>
        </div>
        <div className='modal-body'>

        <button className='facebook' onClick={()=>this.login()}>Facebook</button><br/>
        <button className='google' onClick={()=>this.g_login()} >Google</button>
       {error &&<p style={{color:'red'}}>{error}</p>}
       
        </div>
        <div className='modal-footer'>
            <h3>@Arriba!</h3>
        </div>
    </div>
</div>
}
{/* ==========================USER-MODAL-END=========================== */}



{/* ===========================VAN-MODAL======================== */}
{vanModal &&
    <div id='simpleModal' className='modal'>
        <div className='modal-content'>
            <div className='modal-header'>
            <span className='closeBtn' onClick={()=>this.setState({userModal:false,vanModal:false})}>&times;</span>
            <h2>Van login</h2>
            </div>
            <div className='modal-body'>
    
            <button className='facebook' onClick={()=>this.v_login()}>Facebook</button><br/>
            <button className='google' onClick={()=>this.v_g_login()} >Google</button>
            {error &&<p style={{color:'red'}}>{error}</p>}
            </div>
            <div className='modal-footer'>
                <h3>@Arriba!</h3>
            </div>
        </div>
    </div>
    }
    {/* ==========================VAN-MODAL-END=========================== */}
                    



{/* ===========================USER-LOGGED-IN======================== */}
{userlogin && userModal &&
    <div id='simpleModal' className='modal'>
        <div className='modal-content'>
            <div className='modal-header'>
            <span className='closeBtn' onClick={()=>this.setState({userModal:false})}>&times;</span>
            <h2>Bem vinda</h2>
            </div>
            <div className='modal-body'>
    <img alt={userDetail.name} src={userDetail.photo}  style={{width:'100px',height:'100px',alignSelf:'center'}}/>
    <h3 style={{alignSelf:'center'}}>{userDetail.name}</h3>
    <button className='next' onClick={()=>this.props.history.push('./user/registration')}>Next</button>

            </div>
            <div className='modal-footer'>
                <h3>@Arriba!</h3>
            </div>
        </div>
    </div>
    }
    {/* ==========================USER-LOGGED-END=========================== */}
    
    
    
{/* ===========================VAN-LOGGED-IN======================== */}
{vanlogin && vanModal &&
    <div id='simpleModal' className='modal'>
        <div className='modal-content'>
            <div className='modal-header'>
            <span className='closeBtn' onClick={()=>this.setState({userModal:false,vanModal:false})}>&times;</span>
            <h2>Bem vinda</h2>
            </div>
            <div className='modal-body'>
    <img alt={userDetail.name} src={userDetail.photo}  style={{width:'100px',height:'100px',alignSelf:'center'}}/>
    <h3 style={{alignSelf:'center'}}>{userDetail.name}</h3>
    <button className='next' onClick={()=>this.props.history.push('./driver/registration')}>Next</button>

            </div>
            <div className='modal-footer'>
                <h3>@Arriba!</h3>
            </div>
        </div>
    </div>
    }
    {/* ==========================VAN-LOGGED-END=========================== */}
    
    

            </div>
        )
    }
}
